import i18n from 'modules/core/lib/i18n'

import Employee from 'modules/employees/store/models/Employee'
import {
  allStatusCopies,
  isValidIncidenceStatus,
} from 'modules/payroll_bundle/lib/Incidences/Status'

export const employeeDataUpdatesTranslation = (key: string) => {
  switch (key) {
    case 'address_line_1':
      return i18n.t('incidences.employee_data_updates.address_line_1')
    case 'address_line_2':
      return i18n.t('incidences.employee_data_updates.address_line_2')
    case 'bank_number':
      return i18n.t('incidences.employee_data_updates.bank_number')
    case 'city':
      return i18n.t('incidences.employee_data_updates.city')
    case 'contract':
      return i18n.t('incidences.employee_data_updates.contract')
    case 'country':
      return i18n.t('incidences.employee_data_updates.country')
    case 'first_name':
      return i18n.t('incidences.employee_data_updates.first_name')
    case 'gender':
      return i18n.t('incidences.employee_data_updates.gender')
    case 'identifier':
      return i18n.t('incidences.employee_data_updates.identifier')
    case 'identifier_type':
      return i18n.t('incidences.employee_data_updates.identifier_type')
    case 'irpf':
      return i18n.t('incidences.employee_data_updates.irpf')
    case 'irpf_cents':
      return i18n.t('incidences.employee_data_updates.irpf_cents')
    case 'last_name':
      return i18n.t('incidences.employee_data_updates.last_name')
    case 'nationality':
      return i18n.t('incidences.employee_data_updates.nationality')
    case 'postal_code':
      return i18n.t('incidences.employee_data_updates.postal_code')
    case 'phone_number':
      return i18n.t('incidences.employee_data_updates.phone_number')
    case 'social_security_number':
      return i18n.t('incidences.employee_data_updates.social_security_number')
    case 'state':
      return i18n.t('incidences.employee_data_updates.state')
    case 'swift_bic':
      return i18n.t('incidences.employee_data_updates.swift_bic')
    case 'is_resident':
      return i18n.t('incidences.employee_data_updates.is_resident')
    case 'location_name':
      return i18n.t('incidences.employee_data_updates.location_name')
    case 'legal_entity_id':
      return i18n.t('incidences.employee_data_updates.legal_entity')
    case 'employee_group_id':
      return i18n.t('incidences.employee_data_updates.employee_group')
    case 'tax_id':
      return i18n.t('incidences.employee_data_updates.tax_id')
    case 'email':
      return i18n.t('incidences.employee_data_updates.email')
    case 'personal_email':
      return i18n.t('incidences.employee_data_updates.personal_email')
    case 'birth_name':
      return i18n.t('incidences.employee_data_updates.birth_name')
    case 'teams':
      return i18n.t('incidences.employee_data_updates.team')
    default:
      throw new Error(`Missing translation for incidences.employee_data_updates.${key}`)
  }
}

export const historicChangesTranslations = (key: string, value: string | null = null) => {
  switch (key) {
    case 'address_line_1_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.address_line_1_updated')
    case 'address_line_2_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.address_line_2_updated')
    case 'approval_modified':
      return i18n.t('bookkeepers.incidence.historic_changes.approval_modified')
    case 'bank_number_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.bank_number_updated')
    case 'city_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.city_updated')
    case 'compensation_created':
      return i18n.t('bookkeepers.incidence.historic_changes.compensation_created')
    case 'compensation_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.compensation_updated')
    case 'compensation_deleted':
      return i18n.t('bookkeepers.incidence.historic_changes.compensation_deleted')
    case 'contract_effective_on_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.contract_effective_on_updated')
    case 'contract_ends_on_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.contract_ends_on_updated')
    case 'contract_starts_on_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.contract_starts_on_updated')
    case 'country_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.country_updated')
    case 'created':
      return i18n.t('bookkeepers.incidence.historic_changes.created')
    case 'deleted':
      return i18n.t('bookkeepers.incidence.historic_changes.deleted')
    case 'description_modified':
      return i18n.t('bookkeepers.incidence.historic_changes.description_modified')
    case 'effective_on_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.effective_on_updated')
    case 'effective_date_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.effective_date_updated')
    case 'end_date_modified':
      return i18n.t('bookkeepers.incidence.historic_changes.end_date_modified')
    case 'first_name_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.first_name_updated')
    case 'gender_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.gender_updated')
    case 'identifier_type_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.identifier_type_updated')
    case 'identifier_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.identifier_updated')
    case 'irpf_cents_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.irpf_cents_updated')
    case 'irpf_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.irpf_updated')
    case 'job_title_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.job_title_updated')
    case 'job_level_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.job_level_updated')
    case 'last_name_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.last_name_updated')
    case 'leave_type_modified':
      return i18n.t('bookkeepers.incidence.historic_changes.leave_type_modified')
    case 'nationality_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.nationality_updated')
    case 'postal_code_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.postal_code_updated')
    case 'salary_amount_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.salary_amount_updated')
    case 'salary_frequency_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.salary_frequency_updated')
    case 'social_security_number_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.social_security_number_updated')
    case 'start_date_modified':
      return i18n.t('bookkeepers.incidence.historic_changes.start_date_modified')
    case 'state_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.state_updated')
    case 'swift_bic_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.swift_bic_updated')
    case 'subject_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.subject_updated')
    case 'es_education_level_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.es_education_level_updated')
    case 'es_working_day_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.es_working_day_updated')
    case 'es_contract_type_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.es_contract_type_updated')
    case 'es_contribution_type_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.es_contribution_type_updated')
    case 'es_cno_occupation_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.es_cno_occupation_updated')
    case 'es_regime_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.es_regime_updated')
    case 'es_tariff_group_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.es_tariff_group_updated')
    case 'es_classification_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.es_classification_updated')
    case 'es_occupation_code_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.es_occupation_code_updated')
    case 'es_a3innuva_job_position_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.es_a3innuva_job_position_updated')
    case 'es_job_description_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.es_job_description_updated')
    case 'es_contract_observations_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.es_contract_observations_updated')
    case 'es_professional_category_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.es_professional_category_updated')
    case 'fr_professional_category_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.fr_professional_category_updated')
    case 'terminated_on_modified':
      if (value) {
        return i18n.t('bookkeepers.incidence.historic_changes.terminated_on_modified')
      }

      return i18n.t('bookkeepers.incidence.historic_changes.termination_cancelled')
    case 'termination_reason_type_updated':
      if (value) {
        return i18n.t('bookkeepers.incidence.historic_changes.termination_reason_type_updated')
      }

      return
    case 'trial_period_ends_on_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.trial_period_ends_on_updated')
    case 'working_hours_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.working_hours_updated')
    case 'working_hours_frequency_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.working_hours_frequency_updated')
    case 'max_legal_yearly_hours_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.max_legal_yearly_hours_updated')
    case 'maximum_weekly_hours_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.maximum_weekly_hours_updated')
    case 'working_week_days_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.working_week_days_updated')
    case 'status_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.status_updated')
    case 'residence_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.residence_updated')
    case 'workplace_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.workplace_updated')
    case 'fr_forfait_jours_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.fr_forfait_jours_updated')
    case 'fr_jours_par_an_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.fr_jours_par_an_updated')
    case 'birth_name_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.birth_name_updated')
    case 'teams_updated':
      return i18n.t('bookkeepers.incidence.historic_changes.team_updated')
    default:
      throw new Error(`Missing translation for incidence.historic_changes.${key}`)
  }
}

export const statusTranslation = (
  key: string,
  isBookkeeperView = false,
  inHousePayroll = false
) => {
  if (!isValidIncidenceStatus(key)) {
    throw new Error(`Missing translation for incidence.status.${key}`)
  }
  return allStatusCopies(isBookkeeperView || inHousePayroll)[key]
}

export const employeeTaxResidenceValueTranslation = (key: boolean) => {
  if (key) {
    return i18n.t('employee_form.tax_residence.resident')
  } else {
    return i18n.t('employee_form.tax_residence.not_resident')
  }
}

export const additionalCompensationType = (type: string | undefined, amount: string | null) => {
  const types: Record<string, string> = {
    undefined: i18n.t('compensation.types.undefined'),
    fixed: i18n.t('bookkeepers.additional_compensation.types.fixed', { amount }),
    up_to: i18n.t('bookkeepers.additional_compensation.types.up_to', { amount }),
  }

  if (!type) return types.undefined

  return types[type] || types.undefined
}

export const additionalCompensationLabels = (key: string) => {
  const translations: Record<string, string> = {
    title: i18n.t('bookkeepers.additional_compensation.labels.title'),
    description: i18n.t('bookkeepers.additional_compensation.labels.description'),
    recurrence: i18n.t('bookkeepers.additional_compensation.labels.recurrence'),
    type: i18n.t('bookkeepers.additional_compensation.labels.type'),
  }

  return translations[key] ?? ''
}

export const mandatoryFieldsTranslations = (key: string) => {
  switch (key) {
    case 'first_name':
      return i18n.t('bookkeepers.incidence.details.first_name')
    case 'last_name':
      return i18n.t('bookkeepers.incidence.details.last_name')
    case 'birth_name':
      return i18n.t('bookkeepers.incidence.details.birth_name')
    case 'identifier':
      return i18n.t('bookkeepers.incidence.details.identifier')
    case 'identifier_type':
      return i18n.t('bookkeepers.incidence.details.identifier_type')
    case 'address':
    case 'address_line_1':
      return i18n.t('bookkeepers.incidence.details.address')
    case 'gender':
      return i18n.t('bookkeepers.incidence.details.gender')
    case 'birthday_on':
      return i18n.t('bookkeepers.incidence.details.birthday_on')
    case 'social_security_number':
      return i18n.t('bookkeepers.incidence.details.social_security_number')
    case 'bank_number':
      return i18n.t('bookkeepers.incidence.details.bank_number')
    case 'es_contract_type':
    case 'es_contract_type_name':
    case 'fr_contract_type_name':
      return i18n.t('bookkeepers.incidence.details.contract_type')
    case 'salary_amount':
      return i18n.t('bookkeepers.incidence.details.salary_amount')
    case 'working_hours':
      return i18n.t('bookkeepers.incidence.details.working_hours')
    case 'working_hours_frequency':
      return i18n.t('bookkeepers.incidence.details.working_hours_frequency')
    case 'working_week_days':
      return i18n.t('bookkeepers.incidence.details.working_week_days')
    case 'es_professional_category_name':
    case 'fr_professional_category_name':
      return i18n.t('bookkeepers.incidence.details.professional_category')
    case 'starts_on':
    case 'start_on':
      return i18n.t('bookkeepers.incidence.details.starts_on')
    case 'description':
      return i18n.t('bookkeepers.incidence.details.description')
    case 'terminated_on':
      return i18n.t('bookkeepers.incidence.details.effective_on')
    case 'termination_reason':
    case 'termination_reason_type':
      return i18n.t('bookkeepers.incidence.details.termination_reason')
    case 'remaining_holidays':
      return i18n.t('bookkeepers.incidence.details.remaining_holidays')
    case 'fr_mutual_name':
      return i18n.t('bookkeepers.incidence.details.mutual')
    case 'fr_coefficient':
      return i18n.t('bookkeepers.incidence.details.coefficient')
    case 'company_identifier':
      return i18n.t('bookkeepers.incidence.details.company_identifier')
    case 'seniority_calculation_date':
      return i18n.t('bookkeepers.incidence.details.seniority_calculation_date')
    case 'fr_work_type_name':
      return i18n.t('bookkeepers.incidence.details.work_type')
    case 'fr_employee_type':
      return i18n.t('bookkeepers.incidence.details.fr_employee_type')
    case 'fr_forfait_jours':
      return i18n.t('bookkeepers.incidence.details.fr_forfait_jours')
    case 'country_of_birth':
      return i18n.t('bookkeepers.incidence.details.country_of_birth')
    case 'postal_code':
      return i18n.t('bookkeepers.incidence.details.postal_code')
    case 'country':
      return i18n.t('bookkeepers.incidence.details.country')
    case 'birthplace':
      return i18n.t('bookkeepers.incidence.details.birthplace')
    case 'number_of_dependants':
      return i18n.t('bookkeepers.incidence.details.number_of_dependants')
    case 'civil_status':
      return i18n.t('bookkeepers.incidence.details.civil_status')
    case 'family_situation':
      return i18n.t('bookkeepers.incidence.details.family_situation')
    case 'swift_bic':
      return i18n.t('bookkeepers.incidence.details.swift_bic')
    case 'effective_on':
      return i18n.t('bookkeepers.incidence.details.effective_on')
    case 'nationality':
      return i18n.t('bookkeepers.incidence.details.nationality')
    case 'es_education_level':
      return i18n.t('bookkeepers.incidence.details.education_level')
    case 'job_title':
      return i18n.t('bookkeepers.incidence.details.job_title')
    case 'finish_on':
      return i18n.t('bookkeepers.incidence.details.ends_on')
    case 'teams':
      return i18n.t('bookkeepers.incidence.details.teams')
    default:
      throw new Error(`Missing translation for bookkeepers.incidence.details.${key}`)
  }
}

export const terminationReasonTranslation = (type: string) => {
  switch (type) {
    case Employee.TERMINATION_REASON_TYPE.company:
      return i18n.t('bookkeepers.incidence.termination_reason_type.company_decision')
    case Employee.TERMINATION_REASON_TYPE.employee:
      return i18n.t('bookkeepers.incidence.termination_reason_type.employee_decision')
    case Employee.TERMINATION_REASON_TYPE.others:
      return i18n.t('bookkeepers.incidence.termination_reason_type.others')
    default:
      return ''
  }
}

export const translatedIncidenceName = (
  incidenceType: string,
  customName?: string | null
): string => {
  if (customName) {
    return customName
  }

  switch (incidenceType) {
    case 'address':
      return i18n.t('bookkeepers.incidence.name.address')
    case 'bank':
      return i18n.t('bookkeepers.incidence.name.bank')
    case 'contract':
      return i18n.t('bookkeepers.incidence.name.contract')
    case 'contract_reactivation':
      return i18n.t('bookkeepers.incidence.name.contract_reactivation')
    case 'cost_center':
      return i18n.t('bookkeepers.incidence.name.cost_center')
    case 'gender':
      return i18n.t('bookkeepers.incidence.name.gender')
    case 'hiring':
      return i18n.t('bookkeepers.incidence.name.hiring')
    case 'id':
      return i18n.t('bookkeepers.incidence.name.id')
    case 'irpf':
      return i18n.t('bookkeepers.incidence.name.irpf')
    case 'legal_entity':
      return i18n.t('bookkeepers.incidence.name.legal_entity')
    case 'manual_incidence':
      return i18n.t('bookkeepers.incidence.name.manual_incidence')
    case 'name':
      return i18n.t('bookkeepers.incidence.name.name')
    case 'nationality':
      return i18n.t('bookkeepers.incidence.name.nationality')
    case 'parental':
      return i18n.t('bookkeepers.incidence.name.parental')
    case 'phone_number':
      return i18n.t('bookkeepers.incidence.name.phone_number')
    case 'residence':
      return i18n.t('bookkeepers.incidence.name.residence')
    case 'sick':
      return i18n.t('bookkeepers.incidence.name.sick')
    case 'tax_id':
      return i18n.t('bookkeepers.incidence.name.tax_id')
    case 'termination':
      return i18n.t('bookkeepers.incidence.name.termination')
    case 'workplace':
      return i18n.t('bookkeepers.incidence.name.workplace')
    case 'email':
      return i18n.t('bookkeepers.incidence.name.email')
    case 'team':
      return i18n.t('bookkeepers.incidence.name.team')
    default:
      return incidenceType
  }
}
